<template>
  <div class="chatbot-dialog col-block width-full">
    <div class="chatbot-main-container row-block height-full" :style="{ height: (windowHeight - 350) + 'px', 'max-height': '500px' }">
      <div class="chatbot-main-block col-block width-full" :style="{ flex: 5, width: 0 }">
        <div
          class="chatbot-default-button-container col-block width-full"
          :class="{ active: display['defaultButton'], disabled: ['loading', 'stop', 'busy'].includes(botState) }"
          :style="{ right: (scrollbarSize + 10) + 'px' }"
        >
          <div class="chatbot-default-button-block row-block flex-start">
            <template v-if="display['defaultButton']">
              <div class="avatar-block" :style="{ '--size': '40px' }"></div>
              <div class="chatbot-default-button-main-container col-block" :style="{ flex: 1 }">
                <div
                  class="chatbot-default-button-main-block"
                  :style="{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gridGap: '10px 12px',
                    'max-width': '772px'
                  }"
                >
                  <div
                    class="chatbot-default-button-content-container col-block"
                    v-for="(buttonOption, boindex) in currentButtonOptions"
                    :key="boindex"
                    :style="{
                      grid: 'span 1'
                    }"
                    @click="e => !['loading', 'stop', 'busy'].includes(botState) && sendButtonContent(buttonOption)"
                  >
                    <div class="chatbot-default-button-content icon-block" :style="{ '--size': '40px' }">
                      <img :src="buttonOption.icon" alt="">
                    </div>
                    <div class="chatbot-default-button-content" v-html="buttonOption.title"></div>
                  </div>
                </div>
              </div>
            </template>
            <div class="chatbot-default-button-avatar-container avatar-block center-block" :style="{ '--size': '40px' }" @click="e => display['defaultButton'] = !['loading', 'stop', 'busy'].includes(botState) ? !display['defaultButton'] : false">
              <img :src="require('../../assets/images/chatbot-default-button-icon.svg')" alt="" :style="{ width: '16.5px' }">
            </div>
          </div>
        </div>
        <template v-if="['busy'].includes(botState)">
          <div class="chatbot-bot-busy-container col-block" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="chatbot-bot-busy-title">{{ $t('DIALOG.chatbot.___busyTitle') }}</div>
            <div :style="{ height: '30px' }"></div>
            <div class="chatbot-bot-busy-button-container row-block">
              <button class="main-button circle-button" @click="e => retryConnect()">
                <span>{{ $t('COMMON.button.___retry') }}</span>
              </button>
            </div>
            <div :style="{ flex: 5 }"></div>
          </div>
        </template>
        <template v-else>
          <div ref="chatbot-scroll" class="chatbot-display-container" :style="{ flex: 1 }">
            <div class="col-block width-full" :style="{ height: 0 }">
              <chatDisplay
                :chats="chats"
                :botState="botState"
                :botChatData="botChatData"
              ></chatDisplay>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </template>
      </div>
      <div class="chatbot-agent-container col-block width-full" :style="display['agentSummary'] ? { flex: 3, width: 0 } : { width: '44px' }">
        <div v-show="display['agentSummary']" class="chatbot-agent-main-container col-block width-full" :style="{ flex: 1, height: 0 }">
          <div class="chatbot-agent-main-title-container row-block">
            <div class="chatbot-agent-main-title" :style="{ flex: 1 }">{{ $t('DIALOG.chatbot.agent.___title') }}</div>
            <img class="active-icon" :src="require('../../assets/images/snv-filter-active-icon.svg')" alt="" @click="e => display['agentSummary'] = false">
          </div>
          <div ref="summary-scroll" class="chatbot-agent-main-content-container" :style="{ flex: 1 }">
            <div class="col-block width-full" :style="{ height: 0 }">
              <chatSummary
                :chats="chats"
                :botState="botState"
                :botChatData="botChatData"
              ></chatSummary>
            </div>
          </div>
        </div>
        <div v-show="!display['agentSummary']" class="chatbot-agent-bar-container col-block width-full" :style="{ flex: 1 }">
          <div class="col-block" :style="{ flex: 1 }">
            <img class="active-icon" :src="require('../../assets/images/snv-filter-active-icon.svg')" alt="" @click="e => display['agentSummary'] = true">
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="chatbot-agent-bar-title-container col-block">
            <div class="chatbot-agent-bar-title">{{ $t('DIALOG.chatbot.agent.___title') }}</div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="chatbot-form-container col-block width-full">
      <div class="chatbot-form-block row-block" :style="{ 'max-width': '772px' }">
        <!-- <div class="avatar-block" :style="{ '--size': '40px' }">
          <img v-if="false" :src="require('../../assets/images/bot-avatar.svg')" alt="">
        </div> -->
        <div class="chatbot-form col-block width-full input-group" :style="{ flex: 1 }">
          <input type="text" :placeholder="$t('DIALOG.chatbot.___inputPlaceholder')" :disabled="['loading', 'stop', 'busy'].includes(botState)" v-model="content" @keypress.enter.prevent.stop="e => sendContent(content)">
        </div>
        <div class="chatbot-form-button-container row-block">
          <div class="chatbot-form-button-block row-block">
            <button class="send-button main-button circle-button" :disabled="!content || ['loading', 'stop', 'busy'].includes(botState)" @click="e => sendContent(content)">
              <span>{{ $t('COMMON.button.___send') }}</span>
            </button>
            <div :style="{ flex: 1 }"></div>
          </div>
          <!-- <div class="chatbot-form-option-container row-block">
            <div class="avatar-block" :style="{ '--size': '40px' }">
              <img v-if="false" :src="require('../../assets/images/bot-avatar.svg')" alt="">
            </div>
            <div class="delete-icon icon-block" :class="{ disabled: !chats.length || ['loading', 'stop', 'busy'].includes(botState) }" :style="{ '--size': '40px' }" @click="e => !e.currentTarget.className.split(' ').includes('disabled') ? deleteContentsAlert() : ''">
              <img :src="require('../../assets/images/case-detail-delete-icon.svg')" alt="" :style="{ width: '19px' }">
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="chatbot-button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <!-- <button class="gray-button circle-button" :disabled="!['loading', 'stop', 'busy'].includes(botState)" @click="e => stopBot()">
        <span>{{ $t('COMMON.button.___stop') }}</span>
      </button> -->
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getChat, deleteChat } from '../../api'
import chatDisplay from '../chat/display.vue'
import chatSummary from '../chat/summary.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import userPermission from '../../mixins/userPermission.vue'
import responsitive from '../../mixins/responsitive.vue'
import webSocket from '../../mixins/webSocket.vue'
import { dateFormat, sortData } from '../../constants/global/util'

export default {
  components: {
    chatDisplay,
    chatSummary
  },
  mixins: [
    routeLoading,
    toastMethods,
    userPermission,
    responsitive,
    webSocket
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      threadID: null,
      content: '',
      chats: [],
      buttonPhase: 'default',
      botState: '',
      botChatData: {
        status: [],
        summary: {},
        message: []
      },
      display: {
        'defaultButton': false,
        'agentSummary': false
      }
    }
  },
  channels: {
    ChatChannel: {
      connected () {
        if (!this.chats.length) {
          this.display['defaultButton'] = true
        }
        this.botState = ''
        this.setLoadingAction(false)
      },
      rejected () {
        setTimeout(() => {
          this.initWebSocket()
        }, 5000)
      },
      received (data) {
        switch ((data || {}).event) {
          case 'status': {
            this.botChatData.status.push(data)
            break
          }
          case 'agent_activity': {
            this.botChatData.summary.contents[data.title] = {
              ...data,
              ...(this.botChatData.summary.contents[data.title] || {}),
              status: data.status
            }
            this.setScrollToBottom('summary-scroll')
            break
          }
          case 'answer_delta': {
            this.botChatData.message.push(data)
            this.setScrollToBottom('chatbot-scroll')
            break
          }
          case 'answer_image': {
            this.botChatData.message.push({
              ...data,
              data: [
                '',
                this.parseAssetToString(data.asset),
                ''
              ].join('\n\n')
            })
            this.setScrollToBottom('chatbot-scroll')
            break
          }
          case 'media': {
            // this.botChatData.message.push({
            //   ...data,
            //   data: [
            //     '',
            //     ...data.visual_assets.map(asset => this.parseAssetToString(asset)),
            //     ''
            //   ].join('\n\n')
            // })
            // this.setScrollToBottom('chatbot-scroll')
            break
          }
          case 'done': {
            let answer = (
              data.stream_layout_stable ? sortData(this.botChatData.message || [], data => data.timestamp, 'asc').map(data => data.data).join('')
              : data.content_blocks ? data.content_blocks.map(block => this.parseContentBlock(block)).filter(x => x).join('\n\n')
              : data.answer
            )
            this.botState = ''
            this.chats.push({
              ...this.botChatData,
              message: answer,
              msgType: 'answer'
            })
            this.botChatData = {
              status: [],
              summary: {},
              message: []
            }
            break
          }
          case 'error': {
            if (data.message) {
              this.addToast('error', data.data)
            }
            break
          }
        }
      },
      disconnected () {
        this.display['defaultButton'] = false
        this.botState = 'busy'
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    currentButtonOptions () {
      return {
        'default': [
          {
            icon: require('../../assets/images/chatbot-default-button-clinVar-icon.svg'),
            title: this.$t('DIALOG.chatbot.button.default.clinVar.___title'),
            content: 'DIALOG.chatbot.button.default.clinVar.___content'
          },
          {
            icon: require('../../assets/images/chatbot-default-button-caseReports-icon.svg'),
            title: this.$t('DIALOG.chatbot.button.default.caseReports.___title'),
            content: 'DIALOG.chatbot.button.default.caseReports.___content'
          },
          {
            icon: require('../../assets/images/chatbot-default-button-prevalence-icon.svg'),
            title: this.$t('DIALOG.chatbot.button.default.prevalence.___title'),
            content: 'DIALOG.chatbot.button.default.prevalence.___content'
          },
          {
            icon: require('../../assets/images/chatbot-default-button-disease-icon.svg'),
            title: this.$t('DIALOG.chatbot.button.default.disease.___title'),
            content: 'DIALOG.chatbot.button.default.disease.___content'
          }
        ]
      }[this.buttonPhase]
    },
    // param
    caseData () {
      return this.param.caseData
    },
    project () {
      return this.param.project
    },
    phenotype () {
      return this.param.phenotype
    },
    phenotypeName () {
      return this.phenotype.Phenotype || this.phenotype.disease
    }
  },
  watch: {
    'chats.length' () {
      this.setScrollToBottom('chatbot-scroll')
      this.setScrollToBottom('summary-scroll')
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModal2Action'
    ]),
    async fetchData () {
      if (await this.fetehWebSocketConnections()) {
        await this.fetchChat()
        this.initWebSocket()
      }
    },
    async fetehWebSocketConnections () {
      return true
      // try {
      //   let config = this.$ls.get('userInfo')
      //   let response = await getWebSocketConnections(config)
      //   let connectionCount = response.data.data
      //   if (connectionCount >= 10) {
      //     this.botState = 'busy'
      //     return false
      //   }
      //   return true
      // } catch (error) {
      //   throw error
      // }
    },
    async fetchChat () {
      try {
        let config = this.$ls.get('userInfo')
        let projectID = this.project.id
        let response = await getChat(projectID, config)
        let chats = response.data.data
        let types = ['question', 'answer']
        chats = Array.prototype.concat.apply(
          [],
          chats.map(chat => {
            return types.map(type => {
              return { message: chat[type], msgType: type }
            }).filter(chat => chat.message)
          })
        )
        this.threadID = Object.entries({
          'user': this.user.id,
          'case': this.caseData.id,
          'date': dateFormat(new Date(), 'yyyyMMddhhmmssS')
        }).map(([key, value]) => key + value).join('-')
        this.chats = chats
      } catch (error) {
        throw error
      }
    },
    async retryConnect () {
      this.setLoadingAction(true)
      await this.fetchData()
      this.setLoadingAction(false)
    },
    initWebSocket () {
      this.setLoadingAction(true)
      this.initWs()
    },
    sendButtonContent (option) {
      this.sendContent(
        this.$t(option.content),
        this.$t(option.content)
      )
    },
    sendContent (content, wsContent) {
      this.chats.push({
        message: content,
        msgType: 'question'
      })
      this.display['defaultButton'] = false
      this.content = ''
      this.botState = 'loading'
      this.botChatData.summary = {
        title: wsContent || content,
        timestamp: Date.now(),
        contents: {}
      }
      this.sendWs(wsContent || content, {
        case_id: this.caseData.id,
        thread_id: this.threadID
      })
    },
    deleteContentsAlert () {
      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: '<span style=color:#FA3D3D>' + this.$t('DIALOG.chatbot.___deleteAlert') + '</span>',
          buttons: [
            {
              title: this.$t('COMMON.button.___cancel'),
              type: 'gray',
              result: false
            },
            {
              title: this.$t('COMMON.button.___delete'),
              type: 'alert',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            await this.deleteContents()
            this.setLoadingAction(false)
          }
        }
      })
    },
    async deleteContents () {
      try {
        let config = this.$ls.get('userInfo')
        let projectID = this.project.id
        await deleteChat(projectID, config)
        this.chats = []
        this.display['defaultButton'] = true
      } catch (error) {
        // this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    stopBot () {
      this.unSubscribeWs()
      this.botState = 'stop'
      setTimeout(() => {
        this.subscribeWs()
      }, 100)
    },
    parseContentBlock (block) {
      switch (block.type) {
        case 'text': {
          return block.markdown
        }
        case 'image': {
          return this.parseAssetToString(block.asset)
        }
      }
    },
    parseAssetToString (asset) {
      return '![' + (asset.alt || '') + '](' + asset.url + ')'
    },
    setScrollToBottom (key) {
      if (this.$refs[key]) {
        setTimeout(() => { this.$refs[key].scrollTop = this.$refs[key].scrollHeight })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/chatbot.vue